import React, { useState } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import { PortalApi } from './portalApi';
import { portalErrorMessage, setPortalToken } from './portalHttp';
import { setPortalParty } from './supplier/supplierPortalApi';

// ---- P1-B customer portal ----
const PortalLogin: React.FC = () => {
  const { code = '' } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await PortalApi.login(code, email.trim(), password);
      setPortalToken(r.token);
      // F8: a supplier contact lands in the supplier area; everyone else in the customer area
      const supplier = r.partyType === 'SUPPLIER';
      setPortalParty(supplier ? 'SUPPLIER' : 'CUSTOMER');
      navigate(`/portal/${encodeURIComponent(code)}${supplier ? '/supplier' : ''}`, { replace: true });
    } catch (err) {
      setError(portalErrorMessage(err, 'Invalid e-mail or password'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box component="form" onSubmit={submit}>
      <Typography variant="h6" gutterBottom>Sign in</Typography>
      <Stack spacing={2}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="E-mail" type="email" autoComplete="username" required fullWidth value={email}
          onChange={e => setEmail(e.target.value)} />
        <TextField label="Password" type="password" autoComplete="current-password" required fullWidth value={password}
          onChange={e => setPassword(e.target.value)} />
        <Button type="submit" variant="contained" disabled={busy || !email.trim() || !password}>Sign in</Button>
        <Link component={RouterLink} to={`/portal/${encodeURIComponent(code)}/forgot`} variant="body2">Forgot your password?</Link>
      </Stack>
    </Box>
  );
};

export default PortalLogin;
// ---- end P1-B ----
